import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
    constructor() {
        this.init();
        window.addEventListener('resize', () => {
            this.onResize();
        });
    }

    init() {
        this.initParallax(".section--bio .section--bio__img-container .parallax");
        this.initParallax(".section--cta-gammes .section--cta-gammes__bg-container .parallax");
        this.initParallax(".section--interlayer-image .parallax");
    }

    initParallax(selector) {
        if( !this.scrollTriggers ) {
            this.scrollTriggers = [];
        }

        gsap.utils.toArray(selector).forEach((section) => {
            const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section.parentElement,
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            })
                .fromTo(section, {
                    y: -heightDiff
                }, {
                    y: 0,
                    ease: "none"
                });
            this.scrollTriggers.push(tl.scrollTrigger);
        });
    }

    cleanUp() {
        if( this.scrollTriggers ) {
            this.scrollTriggers.forEach(trigger => trigger.kill());
            this.scrollTriggers = [];
        }
    }

    onResize() {
        this.cleanUp();
        this.init();
    }
}
